import React from "react";
import PropTypes from "prop-types";
import * as FaIcons from "react-icons/fa";
import * as MdIcons from "react-icons/md";

// Mapping of FontAwesome icon names to react-icons components
const ICON_MAP = {
    // Common icons
    "info-circle": FaIcons.FaInfoCircle,
    "check": FaIcons.FaCheck,
    "user": FaIcons.FaUser,
    "exclamation-triangle": FaIcons.FaExclamationTriangle,
    "star-o": FaIcons.FaRegStar,
    "star": FaIcons.FaStar,
    "copy": FaIcons.FaCopy,
    "times": FaIcons.FaTimes,
    "pencil-alt": FaIcons.FaPencilAlt,
    "pencil": FaIcons.FaPencilAlt,
    "cog": FaIcons.FaCog,
    "trash-alt": FaIcons.FaTrashAlt,
    "chart-pie": FaIcons.FaChartPie,
    "plus-circle": FaIcons.FaPlusCircle,
    "ban": FaIcons.FaBan,
    "long-arrow-right": FaIcons.FaLongArrowAltRight,
    "angle-down": FaIcons.FaAngleDown,
    "sign-out": FaIcons.FaSignOutAlt,
    "chevron-circle-right": FaIcons.FaChevronCircleRight,
    "check-circle": FaIcons.FaCheckCircle,
    "circle": FaIcons.FaCircle,
    // Add more mappings as needed
};

/**
 * Icon component that maps FontAwesome icon names to react-icons components
 * Supports both string icon names and array format [style, iconName]
 */
export default function Icon({ icon, className, size, ...props }) {
    let IconComponent;

    if (Array.isArray(icon)) {
        // Handle array format: ["fas", "icon-name"] or ["far", "icon-name"]
        const [, iconName] = icon;
        IconComponent = ICON_MAP[iconName] || FaIcons.FaQuestion;
    } else if (typeof icon === "string") {
        // Handle string format: "icon-name"
        IconComponent = ICON_MAP[icon] || FaIcons.FaQuestion;
    } else {
        // Assume it's already a component
        IconComponent = icon;
    }

    // Handle size prop (react-icons doesn't use size prop, but we can use className)
    const sizeClass = size ? `icon-size-${size}` : "";

    return (
        <IconComponent
            className={`${className || ""} ${sizeClass}`.trim()}
            {...props}
        />
    );
}

Icon.propTypes = {
    icon: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.array,
        PropTypes.elementType
    ]).isRequired,
    className: PropTypes.string,
    size: PropTypes.string
};




// WEBPACK FOOTER //
// ./src/components/Icon.js